// @core/api/endpoints/product/get_product_by_slug.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ProductResponse,
} from '../../../types/product';

const BASE_PATH = '/product';

/**
 * Get product by slug
 * Retrieves a product using its URL-friendly slug identifier. Useful for routing and deep linking within the platform.
 * @public This endpoint does not require authentication
 */
export async function GetProductBySlug(
  slug: string,
  options?: RequestOptions
): Promise<ProductResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/products/by-slug/:slug`;
  requestPath = requestPath.replace(':slug', encodeURIComponent(slug));
  const requestOptions = { ...options, skipAuth: true };
  return client.get<ProductResponse>(requestPath, { ...requestOptions });
}
